import React from "react";

import { Link, LinkProps, Typography, TypographyProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

interface IContactCustomerServiceProps {
  conditionText?: string;
  textProps?: Partial<
    TypographyProps<React.ElementType, { component?: React.ElementType }>
  >;
  linkProps?: Partial<LinkProps>;
}

const ContactCustomerService: React.FC<IContactCustomerServiceProps> = ({
  conditionText = "If you are still having problems",
  textProps = {},
  linkProps = {},
}) => {
  const classes = useStyles();

  return (
    <Typography
      component="p"
      align="center"
      className={classes.paraSmall}
      {...textProps}
    >
      {conditionText}, please contact{" "}
      <Link color="primary" target="_blank" href="/contact" {...linkProps}>
        customer service.
      </Link>
    </Typography>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  paraSmall: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: "14.58px",
    letterSpacing: 1,
  },
}));

export default ContactCustomerService;
